/* eslint-disable @typescript-eslint/no-unsafe-return */
import {useEffect} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useAppSelector} from 'store/hooks';

const NotFound = () => {
	const navigate = useNavigate();
	const user = useAppSelector(state => state.user);

	useEffect(() => {
		if (user.token) {
			navigate('/dashboard');
		} else {
			navigate('/');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.token]);

	if (user.token) {
		return null;
	}

	return (
		<div id="content">
			<div className="total-center container-fluid">
				{/* <!-- 404 Error Text --> */}
				<div className="text-center">
					<div className="error mx-auto" data-text="404">
						404
					</div>
					<p className="lead text-gray-800 mb-5">Page Not Found</p>
					<p className="text-gray-500 mb-0">
						It looks like you found a glitch in the matrix...
					</p>
					<Link to="/">&larr; Back to main</Link>
				</div>
			</div>
		</div>
	);
};

export default NotFound;
